module.exports = __webpack_public_path__ + "static/media/2DGACM12.bf30c478.jpg";